import axiosInstance from "./axiosInstance";

const getCustomerServices = async () => {
  const response = await axiosInstance.get(
    "partner-service/customer/all/subscribtion"
  );
  return response.data;
};

const activateCustomer = async (customerId: string) => {
  const response = await axiosInstance.patch(`customer/activate/${customerId}`);
  return response.data;
};
const deActivateCustomer = async (customerId: string) => {
  const response = await axiosInstance.patch(
    `customer/desactivate/${customerId}`
  );
  return response.data;
};

const ActivateService = async (
  partnerServiceId: string,
  customerId: string
) => {
  const response = await axiosInstance.post(
    "partner-service/customer/subscribe",
    { partnerServiceId, customerId }
  );
  return response.data;
};
const DeactivateService = async (partnerServiceId: string) => {
  const response = await axiosInstance.post(
    "partner-service/customer/unsubscribe",
    { partnerServiceId }
  );
  return response.data;
};
const configCustomerRate = async (
  partnerServiceId: string,
  customerId: string,
  customRate?: number
) => {
  const response = await axiosInstance.post("partner-service/customer/assign", {
    partnerServiceId,
    customerId,
    customRate,
  });
  return response.data;
};

const getTotalCustomer = async () => {
  const response = await axiosInstance.get(
    "customer/total"
  );
  return response.data;
};

const getBalance = async () => {
  const response = await axiosInstance.get(`payments/balance`);
  return response.data;
};

const switchCustomerMode = async () => {
  const response = await axiosInstance.get("customer/mode");
  return response.data;
};

export const customerService = {
  getCustomerServices,
  ActivateService,
  DeactivateService,
  configCustomerRate,
  activateCustomer,
  deActivateCustomer,
  getTotalCustomer,
  getBalance,
  switchCustomerMode
};
